import { createSlice } from '@reduxjs/toolkit';

const tableSlice = createSlice({
  name: 'table',
  initialState: {
    data: [
      {
        tableId: null,
        preparedColumns: []
      }
    ],
    loading: false,
    error: null
  },
  reducers: {
    setTableData: (state, action) => {
      if (!action.payload || action.payload.id == null) {
        state.data = [...state.data, action.payload];
      }

      const idx = state.data.findIndex(item => item.id === action.payload);
      state.data =
        idx !== -1
          ? [...state.data.slice(0, idx), action.payload, ...state.data.slice(idx + 1)]
          : [...state.data, action.payload];
    }
  }
});

export const { setTableData } = tableSlice.actions;
export default tableSlice.reducer;
